import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines class names using clsx and resolves Tailwind CSS conflicts
 * using tailwind-merge. This is the single source of truth for merging
 * Tailwind utility classes — use it everywhere instead of manual
 * template literals or string concatenation.
 *
 * @example
 * cn("px-4 py-2", isActive && "bg-blue-500", "text-white")
 * cn("base-class", { active: isActive, disabled: isDisabled })
 * cn(["px-2", "py-1"], "mx-auto")
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
